const Move = ({ size = 24, fill = "#F3F1F2", color = "#BCBCC0" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="12" cy="12.3906" r="12" fill={fill} />
    <path
      d="M17.9991 9.09936L7.99751 9.09936M14.9909 6.39062L17.9998 9.09655L14.9909 11.8025M6 15.6853H16.0016M9.00881 18.3923L6 15.6864L9.00881 12.9805"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default Move;
